// LIBRARY REACT
import React from "react";

const Backend = () => {
  return (
    <div className="konten__keahlian">
      <h3 className="judul__keahlian">Tools</h3>
      <div className="kotak__keahlian">
        <div className="kelompok__keahlian">
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Google Collab</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">VS Code</h3>
              <span className="tingkat__keahlian">Lanjutan</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Google Looker</h3>
              <span className="tingkat__keahlian">Lanjutan</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Power BI</h3>
              <span className="tingkat__keahlian">Lanjutan</span>
            </div>
          </div>
        </div>
        <div className="kelompok__keahlian">
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Canva</h3>
              <span className="tingkat__keahlian">Ahli</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Microsoft Office</h3>
              <span className="tingkat__keahlian">Lanjutan</span>
            </div>
          </div>
          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">Adobe Photoshop</h3>
              <span className="tingkat__keahlian">Menengah</span>
            </div>
          </div>

          <div className="data__keahlian">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="nama__keahlian">CapCut</h3>
              <span className="tingkat__keahlian">Lanjutan</span>
            </div>
          </div>

          <div className="data__keahlian">
          <i className="bx bx-badge-check"></i>
          <div>
            <h3 className="nama__keahlian">Figma</h3>
            <span className="tingkat__keahlian">Menengah</span>
          </div>
        </div>

        <div className="data__keahlian">
          <i className="bx bx-badge-check"></i>
          <div>
            <h3 className="nama__keahlian">Chat GPT</h3>
            <span className="tingkat__keahlian">Ahli</span>
          </div>
        </div>

        <div className="data__keahlian">
          <i className="bx bx-badge-check"></i>
          <div>
            <h3 className="nama__keahlian">Meta Spark Studio</h3>
            <span className="tingkat__keahlian">Pemula</span>
          </div>
        </div>

        </div>
      </div>
    </div>
  );
};

export default Backend;
